import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service'
import { ApiService } from '@app/utility/api.service' 
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs/observable/timer'
import { assignWith } from 'lodash';


declare var $: any;

@Component({
  selector: 'app-req-document',
  templateUrl: './req-document.component.html',
  styleUrls: ['./req-document.component.scss']
})
export class ReqDocumentComponent implements OnInit {

form: FormGroup;

otpmobile = "";
AddressList: any
contactList: any = [];
contactListAll: any
selectList: any = [];
contact : any;
Contact: any;
telephone1 : string ="";

verifyOtp = "";
lastReqTime: any
disableResentOtp = false

isHaveDup = false

name : string ="";
UID : string ="";

submitted = false;

submittedType = false;
nameall : string ="";

sendorprint  = false;
displayStyle = "none";


otp = ""
otpRef = ""
requestOtpLbl = "ส่ง"
otpTimer: any = ""

ElapseTime: number = 0;
TotalTime: number = 0;
OTPCountDown: string = "";
SubScr: Subscription;

WaitTime: number;
SubScr2: Subscription;

isCheckedAll = false

  constructor(
    private Fb: FormBuilder,
    private Util: UtilService,
    private Api: ApiService, 
  ) 
  { 
 
  }

  async ngOnInit() {
    const thisTs = this;

    
    this.Initcontact() 
    this.contact = await this.getContact()
   
    this.nameall = this.contact.firstname  + (this.contact.lastname == null ? "" : (" " + this.contact.lastname)) 
      
    function match(params: any, data: any) {
      if ($.trim(params.term) === '') {
        return data;
      }
      if (typeof data.text === 'undefined') {
        return null;
      }
      if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) < 0)
        return null;
      else
        return data;
    }

    $('.select2').select2({
      matcher: function (params: any, data: any) {
        if ($.trim(params.term) === '') {
          return data;
        }

        // Do not display the item if there is no 'text' property
        if (typeof data.text === 'undefined') {
          return null;
        }

        if (params.term.length > 1) {
          // `params.term` should be the term that is used for searching
          // `data.text` is the text that is displayed for the data object
          let cris = params.term.split(" ")
          let found = true
          for (var i = 0; i < cris.length; i++) {
            if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
              found = false;
              return null
            }
          }
          if (found) {
            // You can return modified objects from here
            // This includes matching the `children` how you want in nested data sets
            return data;
          }
        }
        // Return `null` if the term should not be displayed
        return null;
      },
      placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
    });

 

    this.InitDropdown() 
 
    $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change')
    
    this.telephone1 = this.contact.telephone1;

    $('.select2').on("change", function (e: any) {
      thisTs.AddressChange(e.target.value);
    });

    
 

  }
  

  async InitDropdown() {

    this.AddressList = JSON.parse(localStorage.getItem("address"));
    if(this.AddressList == null || this.AddressList.length == 0){
      this.AddressList = await this.Api.getMasterAddress();
    localStorage.setItem("address", JSON.stringify(this.AddressList));
  }

  }
  

  async requestOtp() {
    
    this.otpmobile = this.telephone1;

    if(this.otpmobile.length < 10)
    {
      this.Util.ErrorDialog("กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง")
      return;
    }
   
    let reqOtp: any = {
      MobileNo: this.otpmobile 
    }

    await this.Api.postPortal("crm", "RequestOTP", reqOtp).then(async (reqOtpRes: any) => {
      if (this.Util.isSuccessResponse(reqOtpRes)) {

        let smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : "
        smsContent += reqOtpRes.otpNo + " "
        smsContent += "(RefCode : " +reqOtpRes.RefCode  
        smsContent += "(รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น"   

        let sendSms: any = {
          dpa_description: smsContent,
          dpa_phoneno: this.otpmobile
        }
        let sendSmsRes: any = await this.Api.post("crmservice", "sendSms", sendSms)

 

        if (this.Util.isSuccessResponse(sendSmsRes)) {
          this.otpRef = reqOtpRes.RefCode
          this.otpTimer = 59
          this.lastReqTime = new Date()
          this.requestOtpLbl = "ส่งอีกครั้ง"
          this.disableResentOtp = true
          
          if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
            this.TotalTime = 300;
          }
          else {
            this.TotalTime = reqOtpRes.expInMinute * 60;
          }
          this.ElapseTime = 0;
          if (this.SubScr != undefined) {
            this.SubScr.unsubscribe();
          }
          //this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
        }
        else {
          this.Util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
        }
      }
      else {
        this.Util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
      }
    })
  }
   
  async verify() {
    
    if (this.verifyOtp.trim().length > 0) {

      this.Util.ShowWaiting(true);

      let reqCheckOtp: any = {
        OTP: this.verifyOtp.trim(),
        RefCode: this.otpRef.trim(),
        MobileNo: this.telephone1 
      } 

      let Res: any = await this.Api.postPortal("crm", "VerifyOTP", reqCheckOtp)
      if (this.Util.isSuccessResponse(Res)) {
        console.log(Res.IsValid);

        if (Res.IsValid) {
            //update ข้อมูลผ่าน api updateCRM08DROS 
            if(this.sendorprint)
            {
               this.updateCRM08DROS(this.contact);     
               this.Util.ShowWaiting(false)
               window.location.reload();
            }
            else
            {
              this.getFile(this.contact);       
              this.Util.ShowWaiting(false)
            }
            //this.util.SuccessDialog("ขอเอกสารสำเร็จ");
        }
        else {
          this.Util.ShowWaiting(false);
          this.Util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง");
         }
      }
      else {
        this.Util.ShowWaiting(false);
        this.Util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่");
      }
    }
    else{
      this.Util.WarningDialog("กรุณากรอกรหัส OTP");
    }
  }

  CountDownOTP() {
    if (this.ElapseTime == 0 && this.TotalTime == 0) {
      this.SubScr.unsubscribe();
      return;
    }
    if (this.ElapseTime == this.TotalTime) {
      this.SubScr.unsubscribe();
      $("#btnSubmitOTP").attr("disabled", "disabled");
      $("#btnSubmitOTP").html("ยืนยัน");
      this.ElapseTime = 0;
      return;
    }
    
    this.ElapseTime++;
    let RemainingSecs = this.TotalTime - this.ElapseTime;
    let RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
    RemainingSecs = RemainingSecs % 60;
    $("#btnSubmitOTP").html("ยืนยัน " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs);
  }

  CountDownWaitTime() {
    if (this.WaitTime == 0) {
      $("#btnRequestOTP").html("ขอรหัสอีกครั้ง");
      $("#btnRequestOTP").removeAttr("disabled");
      this.SubScr2.unsubscribe();
      return;
    }
    this.WaitTime--;
    $("#btnRequestOTP").html("ขอรหัสอีกครั้ง " + this.WaitTime);
  }

  async updateCRM08DROS(inputcontact: any) {

    let that = this;
    let req: any;
    req = [];

    try {

      var Addresstext = this.contact.dpa_contact_homeno;
      var MooNotext =  this.contact.dpa_contact_moo;
      var StreetNametext = this.contact.dpa_contact_street;
      var subdistic = this.contact.dpa_contact_subdistict;
      var Zipcodetext = this.contact.dpa_contact_postcodename;
      var UIDtext = this.UID; 
      var MobileNo = this.otpmobile;
      $('.row-checker:checkbox:checked').each(function () {

        let value = {
          RequestedNo: $(this).val()
        }
        //console.log(value.RequestedNo);

        let reqdetail: any = { 
        DROSRequestNo: value.RequestedNo, 
        UID : UIDtext,
        Status : "P",
        Address : Addresstext,
        MooNo : MooNotext,
        StreetName : StreetNametext,
        LocationCode : subdistic,
        Zipcode : Zipcodetext, 
        PhoneNo : MobileNo,
      }

        req.push(reqdetail);
      })

      //console.log(req[0]);
      //console.log(req[1]);
      let Res = await this.Api.post("crmservice", "updateCRM08DROS", req);
       
        if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 200) {
          this.displayStyle = "none";
          this.otpRef = "";
          this.verifyOtp ="";
          this.disableResentOtp = false          
          this.Util.ShowWaiting(false)
          this.Util.SuccessDialog("ขอเอกสารสำเร็จ")
        }
        else if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 201)
        {
          this.displayStyle = "none";
          this.otpRef = "";
          this.verifyOtp ="";
          this.disableResentOtp = false          
          this.Util.ShowWaiting(false)
          this.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ มีคำขอซ้ำในระบบ")
        }
        else
        {
          this.displayStyle = "none";
          this.otpRef = "";
          this.verifyOtp ="";
          this.disableResentOtp = false          
          this.Util.ShowWaiting(false)
          this.Util.ErrorDialog("ขอเอกสารไม่สำเร็จ")
        }
      

    }
    catch (e) {
      console.error(e)
    }
  }

  async getFile(inputcontact: any) {

    let that = this;
    let req: any;
    req = [];
    let filedata: any;
    filedata = [];


    try {
 
      $('.row-checker:checkbox:checked').each(function () {

        
        var row = $(this).closest("tr")[0]; 
        let value = {
          RequestedNo: $(this).val(),
          FilePath: row.cells[5].innerHTML
        }
        req.push(value);

         })
         console.log(req);

         for (const reqs of req) 
         { 
            console.log(reqs.FilePath)
            let para = "FilePath=" + reqs.FilePath;
            //let para = reqs.FilePath.toString();
            let tmp: any = await this.Api.get("crmservice", "getFileDROS2", para); 
            var fields = para.split('/');
            var vfilename = fields[fields.length -1];
            const linkSource = tmp.File;
        
            //await this.opennewpage(vfilename,tmp.File);

            /*
            var byteCharacters = atob(tmp.File);
            var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                var fileURL = URL.createObjectURL(file);
            
                console.log(fileURL)
            //window.open(url, '_blank', '');
            var anchor = document.createElement('a');
            anchor.href = fileURL; 
            anchor.target = '_blank'; 
            anchor.click();
            */
              

            
            var objbuilder = '';
            objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
            objbuilder += (linkSource);
            objbuilder += ('" type="application/pdf" class="internal">');
            objbuilder += ('<embed src="data:application/pdf;base64,');
            objbuilder += (linkSource);
            objbuilder += ('" type="application/pdf"  />');
            objbuilder += ('</object>');
        
            var win = window.open("#",vfilename,"_blank");
            win.document.write('<html><title>'+ vfilename +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
            win.document.write(objbuilder);
            win.document.write('</body></html>'); 
            /*
            
            const win2 = window.open("","_blank");
            let html = '';
        
            html += '<html><head><title>' + vfilename + '</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>' ;
            html += '<body style="margin:0!important">';
            html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+encodeURI(linkSource)+'" type="application/pdf" />';
            html += '</body>';
            html += '</html>'; 
            
            setTimeout(() => {
                  win2.document.write(html);
                }, 0);
                  */
             

        }

        

        this.otpRef = "";
        this.verifyOtp ="";
        this.displayStyle = "none";
        this.disableResentOtp = false

      

    }
    catch (e) {
      console.error(e)
    }
  }

  async opennewpage(a: string,b: string ) {

    const win2 = window.open("","_blank");
    let html = '';

    html += '<html><head><title>' + a + '</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>' ;
    html += '<body style="margin:0!important">';
    html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+encodeURI(b)+'" type="application/pdf" />';
    html += '</body>';
    html += '</html>'; 
    
    setTimeout(() => {
          win2.document.write(html);
        }, 0);
  }


  async Initcontact() {

    
    let dpa_contact_id = localStorage.getItem("cusid");
    let dpa_contact_account =localStorage.getItem("cusaccno");
    let QueryString = "CRM03=true&CRM07=true&CRM02=true";
    if (dpa_contact_id != "")
      QueryString += "&dpa_id=" + dpa_contact_id;
    if (dpa_contact_account != "")
      QueryString += "&dpa_accountno=" + dpa_contact_account;         
    let Res: any = await this.Api.get("crmservice", "contactDros", QueryString);
    this.contactListAll = Res.CRM03.filter((a: any) => a.FilePath != null);  
      for (let itm of this.contactListAll ) {
        
        if(itm.FilePath.split('_')[1] != "05.pdf" && itm.FilePath.split('_')[1] != "07.pdf")
        {
        
          let reqdetail: any = { 
            RequestedNo: itm.RequestedNo, 
            RequestType : itm.RequestType,
            StatusDefinition : itm.StatusDefinition,
            isPrintMessage : itm.IsPrint == 1 ? "มีการขอเอกสารแล้ว" : ("สามารถขอเอกสารได้"),
            UID : itm.UID,
            isPrint : itm.IsPrint,
            FilePath : itm.FilePath,
          }

          this.contactList.push(reqdetail);
        }
      } 

    if(Res != null && Res.CRM02 != null){ 
      this.UID = Res.CRM02[0].UID; 
    } 

  }

  async getContact() {
    let para = "cusid=" + localStorage.getItem("cusid") +   "&accountno=" + localStorage.getItem("cusaccno")
    let tmp: any = await this.Api.get("crmservice", "contact", para)
    if(tmp != null && tmp.length > 0 )
    {
       return tmp[0]
    }
    else
    {
       let value = {  
        firstname: "",
        dpa_contact_homeno: "",
        dpa_contact_moo: "",
        dpa_contact_street: "",
        dpa_contact_subdistict: "",
        dpa_contact_distict: "", 
        dpa_contact_province : "", 
        dpa_contact_postcode: "",
        dpa_contact_country: "",
        telephone1: "",
        dpa_contact_subdistictname: "",
        dpa_contact_distictname: "",
        dpa_contact_provincname: "",
        dpa_contact_postcodename: "",
        dpa_contact_countryname: "",

       }

        return value
      }

    }
    
  

  async senddata(i: number) {

     if(i == 2)
     {
      this.submitted = true;
      this.sendorprint = true;
      if (this.isFormValid()) {
        this.getSelectedContact(i)
      }
     }
     else{
      this.submitted = false;
      this.sendorprint = false;
      this.getSelectedContact(i)
      if (this.selectList.length < 1) {
        this.Util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
      }
      else {
      this.displayStyle = "block";
      }

     }
    } 

  onCheckAllChange() {
    $(".row-checker").prop("checked", this.isCheckedAll)
  }

  getSelectedContact(i: number) {  

    var HaveDup = false
    var that = this;
    that.selectList = []
    if(i == 2)
    {
      $("#tbcrm03 input[type=checkbox]:checked").each(function () {
        var row = $(this).closest("tr")[0];
        
        console.log(row.cells)
        let rowCRM03: any = { 
          isPrint: row.cells[4].innerHTML
        } 
        if(rowCRM03.isPrint != 1)
        { 
          that.selectList.push(rowCRM03);
        }
        else
        {  
          HaveDup = true; 
        }
      }); 
        if(HaveDup)
        {
          this.Util.WarningDialog("กรุณาเลือกเฉพาะรายการที่สามารถขอเอกสารได้");
        }
        else if (that.selectList.length < 1) 
        {
          this.Util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
        }
        else 
        {
         this.displayStyle = "block";
        }
    }
    else{
       
    $('.row-checker:checkbox:checked').each(function () {
      let value = {
        isPrint: $(this).val(), 
      }
      that.selectList.push(value)
      })
    }
 }

  AddressChange(value: any) {
    if (this.AddressList == null)
      return;
    let Rec = this.AddressList.filter((a: any) => a.id == value);
    if (Rec != null && Rec.length > 0) {
      let Values = Rec[0].id.split("|")
      let Text = Rec[0].text.split("|");
      this.contact.dpa_contact_subdistict = Values[0].trim();
      this.contact.dpa_contact_distict = Values[1].trim();
      this.contact.dpa_contact_province = Values[2].trim();
      this.contact.dpa_contact_postcode = Values[3].trim();
      this.contact.dpa_contact_subdistictname = Text[0].trim();
      this.contact.dpa_contact_distictname = Text[1].trim();
      this.contact.dpa_contact_provincname = Text[2].trim();
      this.contact.dpa_contact_postcodename = Text[3].trim(); 
    }
    else {
      this.contact.dpa_contact_subdistict = "";
      this.contact.dpa_contact_distict = "";
      this.contact.dpa_contact_province = "";
      this.contact.dpa_contact_postcode = "";
      this.contact.dpa_contact_subdistictname = "";
      this.contact.dpa_contact_distictname = "";
      this.contact.dpa_contact_provincname = "";
      this.contact.dpa_contact_postcodename = ""; 
    }
  }
  isFormValid() {
    if(this.contact.firstname == null){
      this.contact.firstname = ""
    } 
    if(this.contact.dpa_contact_homeno == null){
      this.contact.dpa_contact_homeno = ""
    } 

    if(this.contact.dpa_contact_subdistictname == null){
      this.contact.dpa_contact_subdistictname = ""
    }

    if(this.contact.dpa_contact_distictname == null){
      this.contact.dpa_contact_distictname = ""
    }

    if(this.contact.dpa_contact_provincname == null){
      this.contact.dpa_contact_provincname = ""
    }
    if(this.contact.dpa_contact_postcodename == null){
      this.contact.dpa_contact_postcodename = ""
    } 

    return this.contact.dpa_contact_homeno != null &&
      this.contact.dpa_contact_homeno.trim().length > 0 && 
      this.contact.dpa_contact_subdistictname != null &&
      this.contact.dpa_contact_subdistictname.trim().length > 0 &&
      this.contact.dpa_contact_distictname != null &&
      this.contact.dpa_contact_distictname.trim().length > 0 &&
      this.contact.dpa_contact_provincname != null &&
      this.contact.dpa_contact_provincname.trim().length > 0 &&
      this.contact.dpa_contact_postcodename != null &&
      this.contact.dpa_contact_postcodename.trim().length > 0
    
      

   
  }
  
  close() {
   
    this.displayStyle = "none";
    this.otpRef = "";
    this.verifyOtp ="";
    this.disableResentOtp = false 
  }

 }





// WEBPACK FOOTER //
// ./src/app/req-document/req-document.component.ts